import FooterModal from "ui/components/Button/FooterModal";
import { formatMoney } from "infra/helpers/number";
import { AreaComumForm } from "core/features/area-comum/typings/index";
import colors from "core/resources/theme/colors";
import { ReservaForm } from "core/features/reservas/typings";
import { Modal } from "antd";
import { Flex, Text, Spinner } from "@chakra-ui/react";
import moment from "moment";
import useAreaComumValorData from "core/features/area-comum/hooks/useAreaComumValorData";
import { formatHorario } from "../../util/helper";

interface ModalResumoProps {
  form: ReservaForm;
  areaComum?: AreaComumForm;
  isOpen: boolean;
  onClose: () => any;
  onSave: () => any;
  isLoadingSave?: boolean;
}

function ModalResumo({
  form,
  areaComum,
  isOpen,
  onClose,
  onSave,
  isLoadingSave,
}: ModalResumoProps) {
  const { data: valor, isLoading: isLoadingValor } = useAreaComumValorData(
    areaComum?.id,
    form.data,
    form?.unidadeId
  );

  return (
    <Modal
      width="800px"
      centered
      className="ant-modal-rounded"
      bodyStyle={{
        height: "max(40vh, 300px)",
        overflow: "auto",
        paddingBottom: 16,
      }}
      visible={isOpen}
      onCancel={onClose}
      title="Resumo da reserva"
      footer={
        <FooterModal
          isDisabled={!!isLoadingSave}
          onSubmit={onSave}
          onClose={onClose}
          showRegisterAnother={false}
          isLoadingSave={!!isLoadingSave}
          primaryButtonText="Confirmar"
          buttonCancelarText="Anterior"
        />
      }
    >
      <Flex gridGap={6}>
        <Flex
          h="100px"
          rounded={8}
          borderWidth={1}
          borderColor={colors.black500}
          alignItems="center"
          justifyContent="center"
          w="150px"
          flexDir="column"
          gridGap={0}
        >
          <Text mb="4px" textAlign="center" lineHeight="15px" fontSize={16}>
            {areaComum?.nome}
          </Text>
          {isLoadingValor ? (
            <Spinner size="sm" color={colors.blue} />
          ) : (
            <Text color={colors.blue}>{formatMoney(valor || 0)}</Text>
          )}
        </Flex>

        <Flex flex={1} flexDir="column" justifyContent="space-between">
          <Flex gridGap={4} w="100%">
            <ItemResumo title="NOME DO EVENTO:" text={form.nome} width={180} />

            <ItemResumo
              title="RESPONSÁVEL/UNIDADE:"
              text={
                (form.responsavelNome || "--") +
                ", " +
                (form.unidadeNumero || "--")
              }
            />
          </Flex>

          <Flex gridGap={4} w="100%">
            <ItemResumo
              width={180}
              title="DATA:"
              text={form.data ? moment(form.data).format("DD/MM/YYYY") : "--"}
            />

            <ItemResumo
              title="HORÁRIO:"
              text={formatHorario(form.horaInicio, form.horaFim)}
            />
          </Flex>
        </Flex>
      </Flex>
    </Modal>
  );
}

const ItemResumo = ({
  title,
  text,
  width,
}: {
  title: string;
  text: string;
  width?: number;
}) => (
  <Flex flexDir="column" flex={1} maxWidth={width}>
    <Text textTransform="uppercase" color={colors.black500} fontSize={14}>
      {title}
    </Text>
    <Text fontSize={14}>{text}</Text>
  </Flex>
);

export default ModalResumo;
